import { apiDeleteUser, apiGetUsers } from "api/userApi";
import SettingsIcon from "assets/icons/SettingsIcon";
import BasicButton from "components/BasicInputs/BasicButton";
import AddCard from "components/List/AddCard";
import Card from "components/List/Card";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import addUserImage from "assets/svg/add-new-users.svg";
import userAvatar from "assets/images/userAvatar.png";
import UserBackground from "assets/svg/users-card-background.svg";
import UserAddFormCard from "./comps/UserFormCard";
import KeyIcon from "assets/icons/KeyIcon";
import { DateToString } from "components/Reports/DateFilter";
import EditIcon from "assets/icons/EditIcon";
import TrashIcon from "assets/icons/TrashIcon";
import { useNavigate, useParams } from "react-router-dom";
import Roles from "./Roles";
import UserFormCard from "./comps/UserFormCard";
import { setConfirm } from "store/actions/appAction";
import { apiGetPermissions } from "api/roleApi";

export interface UsersProps {}

export default function Users(props: UsersProps) {
  const store = useSelector((state: any) => state);
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const { sub } = useParams();
  const token = store.businessReducer.business?.token;
  const users: any[] = store.userReducer.users || [];

  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState<number>();

  useEffect(() => {
    apiGetPermissions(token, null, dispatch);
    dispatch(apiGetUsers(token));
  }, [token]);

  if (sub === "roles") {
    return <Roles />;
  }

  return (
    <div className="flex items-center flex-wrap">
      <div className="flex items-center justify-between w-full">
        <span className="text-xl text-[#5B5B5C]">مدیریت کاربران</span>
        <div>
          <BasicButton
            onClick={() => {
              navigate(`/settings/userManagement/roles`);
            }}
          >
            <SettingsIcon color="#1062D0" scale={0.7} />
            <span>مدیریت نقش ها</span>
          </BasicButton>
        </div>
      </div>
      <div className="w-full flex items-start justify-start gap-8 my-10 flex-wrap">
        {users.map((user, i) => {
          const title = `${user.firstName} ${user.lastName}`;
          const role = user.Roles[0];
          const roleTitle = role?.fa_title;
          if (edit === user.id) {
            return (
              <UserFormCard
                key={i}
                index={i + 1}
                icon={userAvatar}
                title="ویرایش کاربر"
                onClose={() => setEdit(undefined)}
                user={user}
                isEdit
              />
            );
          }
          return (
            <div key={i} className="cursor-pointer" onClick={() => {}}>
              <Card
                icon={userAvatar}
                bgImage={UserBackground}
                index={i + 1}
                title={title}
                subTitle={user.phone}
                body={
                  <div className="flex items-center gap-2 p-2">
                    <KeyIcon />
                    <span>{roleTitle}</span>
                  </div>
                }
                footer={
                  <div className="flex items-center gap-2 p-2">
                    <span>آخرین ورود: </span>
                    <span>{DateToString(new Date(user.createdAt))}</span>
                  </div>
                }
                menuItems={[
                  {
                    label: "ویرایش",
                    icon: <EditIcon style={{ transform: "scale(0.8)" }} />,
                    onChange: () => {
                      setEdit(user.id);
                    },
                  },
                  {
                    label: "حذف کاربر",
                    icon: <TrashIcon color="#CB0B0B" />,
                    onChange: () => {
                      const action: any = () => dispatch(apiDeleteUser(user.id, token));
                      dispatch(setConfirm("آیا مطمئن هستید ؟", action));
                    },
                  },
                ]}
              />
            </div>
          );
        })}
        {!add ? (
          <AddCard
            icon={<img src={addUserImage} alt="" className="h-full" />}
            label="افزودن کاربر جدید"
            onClick={() => setAdd(true)}
          />
        ) : (
          <UserFormCard
            index={users.length + 1}
            icon={userAvatar}
            title="افزودن کاربر جدید"
            onClose={() => setAdd(false)}
          />
        )}
      </div>
    </div>
  );
}
